module.exports = __webpack_public_path__ + "static/jon-107fe59b6583eccf3c16aa85b3aef9f2.gif";